import { Form, Row, Col } from "react-bootstrap";
import "./style.css";
import { getProductList } from "../../../services/auth.api";
import { useEffect, useState } from "react";
import { dateConversion } from "../../../utils/formatDate";
import calenderIcon from "../../../assets/images/calenderIcon.svg"

interface CertificateScopeProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  rowData: any;
}

const FscCertificateScope = [
  {
    label: "FSC-STD-40-003 - Multiple Sites/Group", value: "FSC_STD_Multiple_Sites_Group__c",
  },
  {
    lebel: "FSC-STD-40-005 - Controlled Wood Sourcing", value: "FSC_STD_Controlled_Wood_Sourcing__c",
  },
  {
    lebel: "FSC-STD-40-006-V2-0 Project Certification", value: "FSC_STD_Project_Certification__c",
  },
  {
    lebel: "FSC-STD-40-004 - Chain of Custody", value: "FSC_STD_Chain_Of_Custody__c",
  },
  {
    lebel: "FSC-STD-50-001 – Trademark Use", value: "FSC_STD_Trademark_Use__c",
  },
  {
    lebel: "FSC-STD-40-007 - Reclaimed Material", value: "FSC_STD_Reclaimed_Material__c",
  }
];

const CertificateScope: React.FC<CertificateScopeProps> = ({
  formData,
  setFormData,
  rowData,
}) => {
  const [opportunityData, setOpportunityData] = useState<any>([]);

  const fetchData = async () => {
    if (rowData) {
      await getProductList(rowData.opportunityId).then((response => {
        setOpportunityData(response);
      }))

    }
  };

  useEffect(() => {
    fetchData()
  }, [rowData, setOpportunityData])


  return (
    <div className="" style={{ backgroundColor: "#EDEDED" }}>
      <div className="px-4"  style={{ backgroundColor: "#FFF" }}>
        <Form.Label className="me-5">
          Total Number of Sites Included in the Certificate (excluding
          outsourcers): &nbsp; {
            formData.certificateScope.Allowable_Size_Limit__c || "0"
          }
        </Form.Label>
      </div>
      {opportunityData.opportunityCertificates && opportunityData.opportunityCertificates.map((opportunity: any, index: number) => (
        <div className="p-4 mb-2" key={index} style={{ color: "#353535", backgroundColor: "#ffff", marginBottom: "3px" }} >
          <p className="opportunity-header">{opportunity.ProgramName__c}</p>
          <Row className="">
            <Col xs={12} sm={6} md={6}>
              <p><span className="opportunity-sub-header" >Chain of Custody Code:&nbsp;</span>{opportunity.Certificate_Number__c || "--"}</p>
              <p><span className="opportunity-sub-header" >Controlled Wood Code:&nbsp;</span> {opportunity.Controlled_Wood_Number__c || "--"}</p>
            </Col>
            <Col xs={12} sm={6} md={6}>
              <div className="certificate-date-box">
                <p className="certificate-date-text"><span className="opportunity-sub-header" >Issue Date:&nbsp;</span></p>

                <span className="certificate-date mx-2">
                  <img className="certificate-cal" src={calenderIcon} />
                  {opportunity.ValidFrom__c ? dateConversion(opportunity.ValidFrom__c, "DD MMMM YYYY") : "--"}
                </span>
              </div>
              <div className="certificate-date-box">
                <p className="certificate-date-text"><span className="opportunity-sub-header" >Expire Date:&nbsp;</span></p>

                <span className="certificate-date mx-1">
                  <img className="certificate-cal" src={calenderIcon} />
                  {opportunity.Valid_Through__c ? dateConversion(opportunity.Valid_Through__c, "DD MMMM YYYY") : "--"}
                </span>
              </div>
            </Col>
          </Row>
          <hr />
          <div>
            <p>Application Standards</p>
            <Row>
              <Col xs={12} sm={6} md={4}>
                <Form.Check
                  type="checkbox"
                  id="na-checkbox"
                  label="FSC-STD-40-003 - Multiple Sites/Group"
                  defaultChecked={formData.certificateScope.FSC_STD_Multiple_Sites_Group__c}
                  className="certificate-checkbox"
                  disabled
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Form.Check
                  type="checkbox"
                  id="na-checkbox"
                  label="FSC-STD-40-005 - Controlled Wood Sourcing"
                  defaultChecked={formData.certificateScope.FSC_STD_Controlled_Wood_Sourcing__c}
                  className="certificate-checkbox"
                  disabled
                /></Col>
              <Col xs={12} sm={6} md={4}>
                <Form.Check
                  type="checkbox"
                  id="na-checkbox"
                  label="FSC-STD-40-006-V2-0 Project Certification "
                  defaultChecked={formData.certificateScope.FSC_STD_Project_Certification__c}
                  className="certificate-checkbox"
                  disabled
                /></Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={4}>
                <Form.Check
                  type="checkbox"
                  id="na-checkbox"
                  label="FSC-STD-40-004 - Chain of Custody"
                  defaultChecked={formData.certificateScope.FSC_STD_Chain_Of_Custody__c}
                  className="certificate-checkbox"
                  disabled
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Form.Check
                  type="checkbox"
                  id="na-checkbox"
                  label="FSC-STD-50-001 – Trademark Use"
                  defaultChecked={formData.certificateScope.FSC_STD_Trademark_Use__c}
                  className="certificate-checkbox"
                  disabled
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Form.Check
                  type="checkbox"
                  id="na-checkbox"
                  label="FSC-STD-40-007 - Reclaimed Material"
                  defaultChecked={formData.certificateScope.FSC_STD_Reclaimed_Material__c}
                  className="certificate-checkbox"
                  disabled
                />
              </Col>
            </Row>
          </div>
        </div>
      ))}
      {/* <Row className="mb-3">
        <Col xs={12} sm={6} md={2}>
          <Form.Label> Scope</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope?.FSC?.selectedScope}
          </p>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <Form.Label>Trademark License Code</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope?.FSC?.trademarkLicenseCode}
          </p>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <Form.Label>Applicable Standards</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope.FSC.applicableStandards.join(", ")}
          </p>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} sm={6} md={2}>
          <Form.Label>Chain of Custody Code</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope?.FSC?.chainOfCustodyCode}
          </p>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <Form.Label>Issue Date</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope?.FSC?.issueDate}
          </p>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={6} md={2}>
          <Form.Label>Controlled Wood Code</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope?.FSC?.controlledWoodCode}
          </p>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <Form.Label>Expiry Date</Form.Label>
        </Col>
        <Col xs={12} sm={6} md={2}>
          <p className="certificate-scope-value">
            {formData.CertificateScope?.FSC?.expiryDate}
          </p>
        </Col>
      </Row> */}
    </div>
  );
};

export default CertificateScope;
